import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "../../Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "../../Redux/Actions/actionTypes";
import * as FileManagementActions from "../../Redux/Actions/FileManagementAction";
import FileUploadRequest from "../../Communication/ApiClasses/FileUploadRequest";

// worker
function* handleFileUploadRequest(action) {
  yield put(doLoadingStart(`${actionTypes.FILE_UPLOAD_REQUEST}_SAGA`));

  const { accountId, file, fileType, description, callback } = action.payload;

  const fileUploadApi = new FileUploadRequest(
    accountId,
    file,
    fileType,
    description
  );

  try {
    const result = yield call(fileUploadApi.getData.bind(fileUploadApi));
    yield put(FileManagementActions.uploadFileSuccess(result));
    if (callback) {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(FileManagementActions.uploadFileError(error.response || error));
    if (callback) {
      yield call(callback, error.response || error);
    }
  } finally {
    yield put(doLoadingFinish(`${actionTypes.FILE_UPLOAD_REQUEST}_SAGA`));
  }
}

// watcher
export default function* fileUploadWatcherSaga() {
  yield takeLatest(actionTypes.FILE_UPLOAD_REQUEST, handleFileUploadRequest);
}
